<mat-card>
  <mat-card-title class="title-center">View Processed Result Stats</mat-card-title>
  <mat-card-content>
    <div class="row g-3">
      <!-- Course Dropdown -->
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Select Course</mat-label>
        <mat-select [(ngModel)]="selectedCourseId">
          <mat-option *ngFor="let course of courseList" [value]="course.id">
            {{ course.name }}-{{course.crs_code}}
          </mat-option>
        </mat-select>
      </mat-form-field>

            <mat-form-field class="w-100" appearance="outline">
          <mat-label>Select Exam Month</mat-label>
          <mat-select [(ngModel)]="exam_month">
            <mat-option *ngFor="let month of months" [value]="month.months_name">
              {{ month.months_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Select Exam Year</mat-label>
          <mat-select [(ngModel)]="exam_year">
            <mat-option *ngFor="let year of years" [value]="year.year_name">
              {{ year.year_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

      <!-- Search Button -->
      <button mat-raised-button color="primary" (click)="onFiltersChange()" [disabled]="!selectedCourseId || !exam_month || !exam_year">
        View Stats
      </button>

    </div>
    <div class="search-wrapper">
        <mat-form-field appearance="outline" class="search-input">
          <mat-label>Search students</mat-label>
          <input
            matInput
            [(ngModel)]="searchText"
            placeholder="Search by register no"
          />
        </mat-form-field>
      
        <button mat-flat-button color="primary" (click)="applyFilter()" class="search-btn">
          Search
        </button>
        <button mat-flat-button color="primary" (click)="fetchProcessedStats_download()">
            Download Full List
        </button>
      </div>
  </mat-card-content>
</mat-card>

<!-- Stats Table -->
<mat-card *ngIf="processedStats?.length">
  <mat-card-title class="title-center">Processed Result Stats</mat-card-title>
  <div class="mat-elevation-z8 table-wrapper">
   <table mat-table [dataSource]="processedStats" class="mat-elevation-z8" style="font-size: 8px !important;">

    <!-- SL No -->
<ng-container matColumnDef="sl_no">
  <th mat-header-cell *matHeaderCellDef>Sl No</th>
  <td mat-cell *matCellDef="let row; let i = index">
    {{ (pagination.page - 1) * pagination.limit + i + 1 }}
  </td>
</ng-container>

  <!-- Register No (Static Column) -->
  <ng-container matColumnDef="register_no">
    <th mat-header-cell *matHeaderCellDef>Register No</th>
    <td mat-cell *matCellDef="let row">{{ row.register_no }}</td>
  </ng-container>

  <!-- Semester Columns (Looped) -->
 <!-- Semester Columns -->
<ng-container *ngFor="let sem of [1, 2, 3, 4, 5, 6]">
  
  <!-- Credits Earned -->
  <ng-container [matColumnDef]="'sem' + sem + '_credits_earned'">
    <th mat-header-cell *matHeaderCellDef>SEM {{ sem }} Credits</th>
    <td mat-cell *matCellDef="let row">{{ row['sem' + sem + '_credits_earned'] }}</td>
  </ng-container>

  <!-- Weighted Average -->
  <ng-container [matColumnDef]="'sem' + sem + '_weighted_average'">
    <th mat-header-cell *matHeaderCellDef>SEM {{ sem }} W.Avg</th>
    <td mat-cell *matCellDef="let row">{{ row['sem' + sem + '_weighted_average'] }}</td>
  </ng-container>

  <!-- SGPA (highlighted) -->
  <ng-container [matColumnDef]="'sem' + sem + '_SGPA'">
    <th mat-header-cell *matHeaderCellDef class="highlight-col">SEM {{ sem }} SGPA</th>
    <td mat-cell *matCellDef="let row" class="highlight-col">{{ row['sem' + sem + '_SGPA'] }}</td>
  </ng-container>

  <!-- Attempt Count + Right Border -->
  <ng-container [matColumnDef]="'sem' + sem + '_attempt_count'">
    <th mat-header-cell *matHeaderCellDef class="sem-divider">SEM {{ sem }} Attempts</th>
    <td mat-cell *matCellDef="let row" class="sem-divider">{{ row['sem' + sem + '_attempt_count'] }}</td>
  </ng-container>

</ng-container>


  <!-- Cumulative Columns -->
  <ng-container matColumnDef="cumulative_credits_earned">
    <th mat-header-cell *matHeaderCellDef>Total Credits</th>
    <td mat-cell *matCellDef="let row">{{ row.cumulative_credits_earned }}</td>
  </ng-container>

<ng-container matColumnDef="cgpa">
  <th mat-header-cell *matHeaderCellDef class="highlight-col">CGPA</th>
  <td mat-cell *matCellDef="let row" class="highlight-col">{{ row.cgpa }}</td>
</ng-container>

  <ng-container matColumnDef="cumulative_percentage">
    <th mat-header-cell *matHeaderCellDef>Percentage</th>
    <td mat-cell *matCellDef="let row">{{ row.cumulative_percentage }}</td>
  </ng-container>

  <ng-container matColumnDef="cumulative_result">
    <th mat-header-cell *matHeaderCellDef>Final Result</th>
    <td mat-cell *matCellDef="let row">{{ row.cumulative_result }}</td>
  </ng-container>

  <ng-container matColumnDef="exam_month">
    <th mat-header-cell *matHeaderCellDef>Month</th>
    <td mat-cell *matCellDef="let row">{{ row.exam_month }}</td>
  </ng-container>

  <ng-container matColumnDef="exam_year">
    <th mat-header-cell *matHeaderCellDef>Year</th>
    <td mat-cell *matCellDef="let row">{{ row.exam_year }}</td>
  </ng-container>

  <!-- Table Header & Row Definitions -->
  <tr mat-header-row *matHeaderRowDef="displayedStatsColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedStatsColumns;"></tr>
</table>

    <mat-paginator
      [pageSizeOptions]="[10, 20, 50,100]"
      [length]="pagination.length"
      [pageIndex]="pagination.page - 1"
      [pageSize]="pagination.limit"
      (page)="pageEvent($event)">
    </mat-paginator>
  </div>
</mat-card>

<!-- Empty state -->
<mat-card *ngIf="processedStats?.length === 0 && statsSearched">
  <mat-card-content>No processed result stats available.</mat-card-content>
</mat-card>
